import { SyntheticEvent } from "react";
import { VentilatedWallLayers } from "@iko-design-center/shared";
import { useTranslation } from "react-i18next";
import {
  allSelectedDownloadState,
  getLayerOptions,
} from "../../../store/ventilated-wall/download";
import { useVentilatedWall } from "../../../store/ventilated-wall/hooks";
import { useModal } from "../../../store/modal/hooks";

type ToggleAllOptions = "DOP" | "technicalFiche";

export function useDownload() {
  const { setDownloadState, downloadState } = useVentilatedWall();
  const { closeModal, displayVentilatedWallDownloadMailModal } = useModal();
  const { t } = useTranslation();

  function selectAll() {
    setDownloadState(allSelectedDownloadState);
  }

  function handleCardClick(e: SyntheticEvent) {
    e.stopPropagation();
  }

  const technicalFicheOptions = getLayerOptions({
    t,
    state: downloadState.technicalFiche,
  });
  const DOPOptions = getLayerOptions({
    t,
    state: downloadState.DOP,
  });

  function toggleAll(kind: ToggleAllOptions) {
    switch (kind) {
      case "technicalFiche":
        const technicalFicheChecked =
          downloadState.technicalFiche.wallType &&
          downloadState.technicalFiche.wallInsulation;

        setDownloadState({
          ...downloadState,
          technicalFiche: {
            wallType: !technicalFicheChecked,
            wallInsulation: !technicalFicheChecked,
          },
        });
        break;
      case "DOP":
        const DOPChecked =
          downloadState.DOP.wallType && downloadState.DOP.wallInsulation;

          setDownloadState({
          ...downloadState,
          DOP: {
            wallType: !DOPChecked,
            wallInsulation: !DOPChecked,
          },
        });
        break;
    }
  }

  function toggleLayersOption(kind: ToggleAllOptions, value: VentilatedWallLayers) {
    switch (kind) {
      case "technicalFiche":
        setDownloadState({
          ...downloadState,
          technicalFiche: {
            ...downloadState.technicalFiche,
            [value]: !downloadState.technicalFiche[value],
          },
        });
        break;
      case "DOP":
        setDownloadState({
          ...downloadState,
          DOP: {
            ...downloadState.DOP,
            [value]: !downloadState.DOP[value],
          },
        });
        break;
    }
  }

  function toggle(
    kind:
      | "specifications"
      | "BIMFile"
      | "screenshots"
      | "thermalCalculation"
      | "processingGuideline"
  ) {
    setDownloadState({
      ...downloadState,
      [kind]: !downloadState[kind],
    });
  }

  function handleDownload() {
    displayVentilatedWallDownloadMailModal();
  }

  return {
    t,
    handleCardClick,
    closeModal,
    selectAll,
    technicalFicheOptions,
    toggleAll,
    toggleLayersOption,
    DOPOptions,
    downloadState,
    toggle,
    handleDownload,
  };
}
